import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map, List } from 'immutable';
import { Button, Row, Col } from 'react-bootstrap';

import t from '../../../lib/I18n';
import OrderTrip from '../../../records/order/Trip';
import Journey from '../../../records/order/Journey';

import BaseModal from '../../general/BaseModal';
import AlertButton from '../AlertButton';
import Checkbox from '../../form/Checkbox';

const JourneySelectionItem = ({ journey, checked, onChange, hideCheckbox = false }) => {
    const baseClass = 'disruption-alerts-journey-selection-item';
    const classes = cn(baseClass, {
        [`${baseClass}--checkable`]: !hideCheckbox
    });

    const labelClass = `${baseClass}-label`;
    const label = (
        <div className={labelClass}>
            <p className={`${labelClass}__stations`}>
                {`${journey.getOrigin().name} to ${journey.getDestination().name}`}
            </p>
            <p className={`${labelClass}__time`}>
                {`Out: ${journey.getDepartureTime().format('ddd Do MMM YYYY HH:mm')}`}
            </p>
        </div>
    );

    return (
        <div className={classes}>
            {hideCheckbox ? label : (
                <Checkbox
                    groupClassName="disruption-alerts-journey-selection-item__checkbox"
                    name="selectedJourneys"
                    label={label}
                    checked={checked}
                    onChange={onChange(journey)}
                    value="yes"
                    darkBackground
                />
            )}
        </div>
    );
};

const JourneySelectorModal = ({ orderTrip, onClose, onConfirm, ...modalProps }) => {
    const journeys = orderTrip.isOpenReturn()
        ? new List([orderTrip.getOutwardJourney()])
        : orderTrip.getJourneys();

    const initialState = journeys.reduce((map, journey) =>
        map.set(journey, true), // Pre-select all journeys
        new Map()
    );
    const [selectedJourneys, setSelectedJourneys] = useState(initialState);

    if (journeys.isEmpty()) {
        return null;
    }

    const toggleJourney = journey => () =>
        setSelectedJourneys(prevSelectedJourneys =>
            prevSelectedJourneys.set(journey, !prevSelectedJourneys.get(journey))
        );

    const handleConfirm = () => onConfirm(
        new List(selectedJourneys.filter(selected => selected).keys())
    );

    const baseClass = 'disruption-alerts-journey-selector-modal';

    const modalFooter = (
        <Fragment>
            <Row className="margin-bottom--sm">
                <Col xs={12} className="text-left">
                    {t('disruptionAlerts.modals.common.disclaimer')}
                </Col>
            </Row>
            <Row>
                <Col xs={12} className={`${baseClass}__footer-actions`}>
                    <Button
                        bsStyle="default"
                        onClick={onClose}
                        className="close action-btn action-btn--auto action-btn--secondary"
                    >
                        {t('button.text.close')}
                    </Button>
                    <AlertButton
                        onClick={handleConfirm}
                        disabled={!selectedJourneys.includes(true)}
                    />
                </Col>
            </Row>
        </Fragment>
    );

    return (
        <BaseModal {...modalProps}
            className={cn(`${baseClass}`, 'modal--sm')}
            useFlex
            footer={modalFooter}
            onClose={onClose}
            hideContinue
        >
            <Row>
                <Col xs={12}>
                    <p>{t('disruptionAlerts.modals.common.intro')}</p>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <p className="margin-bottom--xs">{t('disruptionAlerts.modals.journeySelect.items', { totalJourneys: journeys.size })}</p>
                    {journeys.map(journey => (
                        <JourneySelectionItem
                            journey={journey}
                            checked={selectedJourneys.get(journey)}
                            onChange={toggleJourney}
                            hideCheckbox={journeys.size === 1}
                        />
                    ))}
                </Col>
            </Row>
        </BaseModal>
    );
};

JourneySelectionItem.propTypes = {
    journey: PropTypes.instanceOf(Journey).isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    hideCheckbox: PropTypes.bool,
};

JourneySelectorModal.propTypes = {
    modalProps: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
};

export default JourneySelectorModal;



// WEBPACK FOOTER //
// ./src/components/disruptionAlert/modals/JourneySelectorModal.js